import React from 'react';
import {Image} from 'semantic-ui-react';

import {Props} from './types';
import {Layouts} from '@components';
import constants from '@constants';

import './index.scss';

const Reason: React.FC<Props> = props => {
  const isAuthed = !!props.me.sub;

  return (
    <>
      <div className="a__introduction">
        {!isAuthed && (
          <Layouts.Header.Before
            location={props.location}
            history={props.history}
          />
        )}
        <div className="w__hero-container">
          <div className="w__image">
            <Image
              src={constants.IMAGES.REASON_HERO}
              className="b__hero-left"
            />
          </div>
          <div className="w__hero-right-texts">
            <div className="b__hero-title">AnpiChecker</div>
            <div className="b__hero-message">MESSAGE</div>
            <div className="b__hero-sm-message">
              from
              <br />
              TURN AND FRONTIER
            </div>
          </div>
        </div>
        <div className="b__introduction-text">
          私達、ターン・アンド・フロンティアは創業14年目を迎え、お陰様で関西のクラウドインテグレータとして一定の評価を得ることが出来ました。これはお客様をはじめ、関わっていただいた皆様のご支援があったからこそ実現できた事だと感じています。ありがとうございました。
          <br />
          ターン・アンド・フロンティアは「何か世の中のためになるサービスを送り出そう」という思いからスタートしました。『より多くの人々がIT技術の恩恵にあずかることが出来る社会の実現』それが私達のミッションです。今回その原点に立ち返り、
          無料の安否確認サービス「AnpiChecker」 をリリースすることにしました。
        </div>
        <div className="w__introduction-container-one">
          <div className="b__introduction__title-one">
            なぜ、安否確認サービスなのか
          </div>
          <div className="w__introduction-container-one__wrapper">
            <div className="w__image">
              <Image
                src={constants.IMAGES.CONTENT_ONE}
                className="b__image-man"
              />
              <div className="image-one-wrapper">
                <div className="b__image-man-text-container">
                  日本は災害大国です。
                  <br />
                  「お世話になった方々や社会へのお返しとして、私達が出来ることは何だろうか
                  ──」
                  <br />
                  そう自問自答した結果、考えついたのが社員安否確認サービスでした。
                </div>
                <div className="w__introduction__namecontainer-one">
                  <div className="b__introduction-director">
                    株式会社ターン・アンド・フロンティア
                    <br />
                    代表取締役
                  </div>
                  <div className="b__introduction-director-name">
                    大久保哲也
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="b__section-two">
          <div className="b__introduction-question-right">
            より多くの人々に使ってもらうために
          </div>
          <div className="w__container-two">
            <div className="w__introduction-container-two">
              <div className="w__image-container">
                <Image
                  src={constants.IMAGES.CONTENT_TWO}
                  className="b__introduction-man-two"
                />
                <div className="w__introduction__namecontainer-two">
                  株式会社ターン・アンド・フロンティア
                  <br />
                  執行役員
                  <div className="b__introduction-manager-name">中山晴菜</div>
                </div>
              </div>
              <div className="b__man-two-text">
                <span>
                  災害は人を選びません。どんな人も被害に遭う可能性があります。ところが現状の安否確認サービスは大企業向けで利用料が高額なものが多く、中小も含めたすべての企業が大規模災害に備えて導入するには難しい状況でした。本来であれば安否確認の様な重要な生活権にも関わる安全分野は、経済力に左右されることなく、広く公平に誰もが利用できるものでなければなりません。そこで私達は安否確認サービスを無料で提供しようと考えました。
                  <br />
                  これまで私達を支えてくださったお客様やお取引先には経営者の方もいらっしゃいますが、多くは中堅社員の方々です。無料にすることで、働く方のほとんどが集中する中小零細企業でも導入しやすくなり、安否確認サービスを利用する人々の裾野を広げることができます。
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="w__container-three">
          <div className="w__introduction-container-three">
            <div className="b__introduction-question-three">
              公共的なサービスで社会に貢献する
            </div>
            <div className="w__image">
              <Image
                src={constants.IMAGES.CONTENT_THREE}
                className="b__introduction-man-three"
              />
            </div>
            <div className="b__man-three-text">
              従来の有料サービスは毎月利用料を回収することを前提に事業が構成されています。
              利用料が高額であれば世の中に一向に広まることはありません。
              「Public
              interest（公共の利益）」が求められる災害時のサービスに、ビジネスとしての「利益追求」という概念が加わると、利用者の経済的負担がサービスの普及を妨げる要因となり、社会的利益と相反してしまいます。
              <br />
              いつ災害が起こるかわからない中、緊急時に必要なサービスが社会全体に行き渡っていない状態。それを長期間放置する事は日本という国自体の損失にも繋がっていきます。
              <br />
              私達は安否確認サービスを誰にでも利用してもらえる公共的なサービスにすることで、社会に貢献したいと考えています。
            </div>
          </div>
        </div>
        <div className="w__introduction-container-four">
          <div className="w__header-content">
            <div className="b__introduction-question-right">
              災害の影響を受けにくいクラウドサービス
            </div>
          </div>
          <Image
            src={constants.IMAGES.CONTENT_FOUR}
            className="b__introduction-man-four"
          />
          <div className="w__message-container">
            <div className="b__text-container">
              私達はシステム開発やクラウド利用による低料金なサービス運用など、今まで培ってきたノウハウにより、安否確認サービス「AnpiChecker」を限り無く低コストで運用することが可能です。そして何より、堅実なランニングビジネスであるサーバー運用事業を本業とする私達は、この事業でそもそも儲ける必要がありません。「公共の利益」を最大限追求するためには企業は儲けてはならないのです。
              <br />
              安否確認サービスを運用するコストは赤字の積み重ねとなりますが、
              お世話になった方々や社会へのお返しとして「今、私達が出来ること」は当サービスだと確信しています。
            </div>
          </div>
        </div>
        <div className="w__introduction-container-five">
          <div className="b__introduction-question-five">
            災害時は自動で安否確認
          </div>
          <div className="w__image">
            <Image
              src={constants.IMAGES.CONTENT_FIVE}
              className="b__introduction-man-five"
            />
            <div className="w__text">
              <div className="b__image-man-five-text">
                AnpiChecker
                は事前に登録することで、地震発生時に安否確認通知を自動一斉送信します。メールを受け取った人はタップで質問に答えるだけで安否報告が完了するので、管理者は管理画面を使って素早く簡単に各社員の安否状況を確認できます。また、
                追加機能として電話による自動安否確認にも対応しました。この機能については無料提供が大変難しいため有料ではありますが、オプションとして可能な限り安価にご用意しました。もちろん、無料でご提供する標準機能でも必要十分な安否確認が可能ですので、安心してご利用いただきたいと思います。
                <br />
                私達は、安全が確認出来ていない中での無理な出社や帰宅困難者の削減に、当サービスが大きな効果を発揮すると確信しています。ひとりでも多くの方にAnpiCheckerをご利用いただくことで、被害の軽減に貢献できることを願っています。
              </div>
            </div>
          </div>
        </div>
      </div>
      {!isAuthed && <Layouts.Footer.Main />}
    </>
  );
};

export default Reason;
